export interface IPropertiesRegistriesModel {
  uuid?: string
  id?: number
  property_id?: number
  description?: string
  order?: string
  path?: File
  status?: 'active' | 'replaced'
}

export const propertiesRegistriesModelInitValues: IPropertiesRegistriesModel = {
  description: '',
}
